import React, {Component} from 'react';
import {SortableContainer, SortableElement, SortableHandle, arrayMove} from 'react-sortable-hoc';
import FontAwesome from 'react-fontawesome';
import firebase from 'firebase/app';
import 'firebase/database';
import LayerDialog from './layer-dialog';
import NewLayerDialog from './new-layer-dialog';

/** @class LayerList
 * A component for editing and rearranging a
 * list of stage layers.
 */
export default class LayerListComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      layers:[],
      selectedLayer: '',
      showNewLayerDialog: false
    }
    this.dataURL = props.dataURL;
    this.firebaseRef = firebase.database()
      .ref(this.props.dataURL).orderByChild('order');
    this.handleSortEnd = this.handleSortEnd.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleUnselect = this.handleUnselect.bind(this);
    this.handleNewLayer = this.handleNewLayer.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.toggleNewLayerDialog = this.toggleNewLayerDialog.bind(this);
  }
  /** @function componentWillMount
    * Connects the component to the corresponding entry
    * in the firebase database.
    */
  componentWillMount(){
    this.firebaseRef.on('value', snapshot =>{
      var layers = [];
      snapshot.forEach((child) => {
        layers.push({
          id: child.key,
          data: child.val(),
          dataURL: `${this.dataURL}/${child.key}`
        });
      });
      this.setState({layers: layers});
    });
  }
  /** @function componentWillUnmount
    * Disconnects the component from the firebase database.
    */
  componentWillUnmount(){
    this.firebaseRef.off();
  }
  /** @function handleSelect
    * Opens an edit dialog for the selected layer
    * @param {string} id - the index of the layer
    * in the layer list.
    */
  handleSelect(id) {
    this.setState({selectedLayer: id});
  }
  /** @function handleUnselect
    * Closes the edit dialog.
    */
  handleUnselect() {
    this.setState({selectedLayer: ''});
  }
  /** @function handleRemove
    * Removes the selected layer from the database
    * @param {string} id - the id of the layer in the database
    */
  handleRemove(id) {
    const dataURL = `${this.props.dataURL}/${id}`;
    firebase.database().ref(dataURL).remove();
    firebase.storage().ref().child(dataURL).delete().catch(e=>{});
  }
  /** @function handleSortEnd
    * Applies user-sorting to the layer list.
    * @param {Object} {oldIndex, newIndex} the
    * two items to swap in the layer list.
    */
  handleSortEnd({oldIndex, newIndex}){
    var layers = arrayMove(this.state.layers, oldIndex, newIndex);
    var updates = {}
    layers.forEach((layer, i) => {
      if(layer.data.order !== i) {
        layer.data.order = i;
        updates[layer.dataURL] = layer.data;
      }
    });
    firebase.database().ref().update(updates);
  }
  /** @function toggleNewLayerDialog
    * Toggles the visibility of the NewLayerDialog
    */
  toggleNewLayerDialog() {
    this.setState({
      showNewLayerDialog: !this.state.showNewLayerDialog
    });
  }
  /** @function handleNewLayer
    * Creates a new layer item of the specified type
    * and adds it to the layers array.
    * @param {String} type - the type of the layer to add.
    */
  handleNewLayer(type) {
    const index = this.state.layers.length;
    var newLayer = {
      name: "New Layer",
      type: type,
      order: index,
      x: 0,
      y: 0
    }
    if(type==="animation") newLayer.frames = [];
    if(type==="parallax") newLayer.scale = 1.0;
    this.setState({
      showNewLayerDialog: false,
      showEditDialog: index
    });
    firebase.database().ref(this.dataURL).push(newLayer);
  }
  /** @function render
    * Renders the component.
    */
  render() {
    const editDialogs = this.state.layers.map((layer, index) => (
      <LayerDialog
        show={this.state.selectedLayer === layer.id}
        key={'edit-dialog-'+index}
        layer={layer.data}
        dataURL={layer.dataURL}
        onExit={()=>this.handleUnselect(layer.id)}
        />
    ));
    return (
      <div>
        <label>Layers</label>
        <SortableList
          items={this.state.layers}
          useDragHandle={true}
          onSortEnd={this.handleSortEnd}
          onRemoveLayer={this.handleRemove}
          onSelectLayer={this.handleSelect}
          onUnselectLayer={this.handleUnselect}
          />
        <button onClick={this.toggleNewLayerDialog}>
          <FontAwesome name="plus"/>
          Add New Layer
        </button>
        <NewLayerDialog show={this.state.showNewLayerDialog}
          onChooseType={this.handleNewLayer}
          onExit={this.toggleNewLayerDialog}
          />
        {editDialogs}
      </div>
    );
  }
}

/* A Drag handle for the sortable list */
const DragHandle = SortableHandle(() => <FontAwesome name="reorder"/>);

/* An item in the sortable list */
const SortableListItem = SortableElement((props) => {
  return(
    <div className="stage-layer-list-item">
      <DragHandle />
      {props.layer.name}
      {
        (props.layer.type !== "content") ?
          <span>
            <FontAwesome name="edit"
              style={{color: "#965ba5"}}
              onClick={props.onSelectLayer}
              />
            <FontAwesome name="times"
              style={{color: "red"}}
              onClick={props.onRemoveLayer}
              />
          </span>
        : <span style={{width: '4rem'}}></span>
      }
    </div>
  );
});

/* The sortable list */
const SortableList = SortableContainer((props) => {
  return (
    <div className="stage-layer-list">
      {props.items.map((layer, index) => (
        <SortableListItem
          key={`item-${index}`}
          index={index}
          layer={layer.data}
          onSelectLayer={()=>{props.onSelectLayer(layer.id)}}
          onRemoveLayer={()=>{props.onRemoveLayer(layer.id)}}
          />
      ))}
    </div>
  );
});



// WEBPACK FOOTER //
// ./src/stage-editor/layer-list.js